const weeklyPushNotificationTypes = {
  RESET_WEEKLY_PUSH_NOTIFICATION_STATE: 'RESET_WEEKLY_PUSH_NOTIFICATION_STATE',
  CREATE_WEEKLY_PUSH_NOTIFICATION: {
    REQUEST: 'CREATE_WEEKLY_PUSH_NOTIFICATION.REQUEST',
    SUCCESS: 'CREATE_WEEKLY_PUSH_NOTIFICATION.SUCCESS',
    FAILURE: 'CREATE_WEEKLY_PUSH_NOTIFICATION.FAILURE',
  },
  UPDATE_WEEKLY_PUSH_NOTIFICATION: {
    REQUEST: 'UPDATE_WEEKLY_PUSH_NOTIFICATION.REQUEST',
    SUCCESS: 'UPDATE_WEEKLY_PUSH_NOTIFICATION.SUCCESS',
    FAILURE: 'UPDATE_WEEKLY_PUSH_NOTIFICATION.FAILURE',
  },
  FETCH_WEEKLY_PUSH_NOTIFICATIONS: {
    REQUEST: 'FETCH_WEEKLY_PUSH_NOTIFICATIONS.REQUEST',
    SUCCESS: 'FETCH_WEEKLY_PUSH_NOTIFICATIONS.SUCCESS',
    FAILURE: 'FETCH_WEEKLY_PUSH_NOTIFICATIONS.FAILURE',
  },
};

export default weeklyPushNotificationTypes;
